import { gql } from '@apollo/client';

export const EDIT_DEFAULT_META_MUTATION = gql`
  mutation editDefaultMeta($key: String!, $value: String!) {
    editDefaultMeta(key: $key, value: $value) {
      success
    }
  }
`;
